import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"
import './Css/Skills.css';
import siteConfig from "../config/site.config";

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx">
              <h2>Skills</h2>
              <p>“My technical skills and expertise in various programming languages, technologies, and development tools.”</p>
              <Carousel responsive={responsive} infinite={true} className="skill-slider">
                {siteConfig.skills.map((skill, index) => (
                  <div className="skill-item" key={index}>
                    <div className="circular-progress" style={{'--percentage': skill.percentage}}>
                      <div className="inner">
                        <span className="percentage">{skill.percentage}%</span>
                      </div>
                    </div>
                    <h5>{skill.name}</h5>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Background" />
    </section>
  )
}
